/**
 * BlobをデータUrlに変換する。
 * @param {Blob} blob - データ
 * @return {Promise<string>} - データURL
 */
export default async function fileToUrl(blob: Blob): Promise<string> {
  const reader = new FileReader()

  return new Promise<string>((resolve, reject) => {
    reader.onload = (event: Event) => {
      resolve(reader.result)
    }
    reader.onerror = () => {
      reject('画像の読み込みに失敗しました。')
    }
    reader.readAsDataURL(blob)
  })
}
